<!--拣货明细-拣货明细详细弹框 -->
<template>
  <van-overlay :show="show" @click="onSendClose">
    <div class="content" v-if="info" @click.stop>
      <div class="tool">
        <label>拣货明细</label>
        <i class="iconfont guanbi" @click="onSendClose"></i>
      </div>
      <div class="content-main">
        <section>
          <label>库位:</label>
          <label>{{ info.slCode }}</label>
        </section>
        <!--                <section>-->
        <!--                    <label>板号:</label>-->
        <!--                    <label>{{info.bandSn}}</label>-->
        <!--                </section>-->
        <section>
          <label>国际编码:</label>
          <label>{{ info.barCode }}</label>
        </section>
        <section>
          <label>商品名称:</label>
          <label>{{ info.productName }}</label>
        </section>
        <section v-if="info.stockInfo">
          <label>效期:</label>
          <label>{{ info.stockInfo.productDate | dateSub }} ~ {{ info.stockInfo.invalidDate | dateSub }}</label>
        </section>
        <section v-if="info.stockInfo">
          <label>规格:</label>
          <label>{{ info.stockInfo.specVal }}</label>
        </section>
        <!--                <section v-if="info.stockInfo">-->
        <!--                    <label>项次:</label>-->
        <!--                    <label>{{info.stockInfo.itemSn}}</label>-->
        <!--                </section>-->
        <section>
          <label>不良品状态:</label>
          <label>{{ info.defectFlag ? "不良品" : "良品" }}</label>
        </section>
        <section>
          <label>商品状态:</label>
          <label v-if="info.stockInfo && info.stockInfo.productStatus && info.stockInfo.productStatus === 1">
            良品
          </label>
          <label v-else-if="info.stockInfo && info.stockInfo.productStatus && info.stockInfo.productStatus === 2">
            不良品
          </label>
          <label v-else-if="info.stockInfo && info.stockInfo.productStatus && info.stockInfo.productStatus === 3">
            良品锁定
          </label>
          <label v-else-if="info.stockInfo && info.stockInfo.productStatus && info.stockInfo.productStatus === 4">
            不良品锁定
          </label>
        </section>
        <section>
          <label>待拣数量:</label>
          <label><span class="span-unpick">{{ info.qty - info.pickQty }}</span></label>
        </section>
        <section>
          <label>已拣数量:</label>
          <label><span class="span-picked">{{ info.pickQty }}</span></label>
        </section>
        <section>
          <label>拣货状态:</label>
          <label v-if="info.pickQty===0"><span class="span-unpick">{{ "未拣货" }}</span></label>
          <label v-else-if="info.pickQty !== info.qty"><span class="span-picking">{{ "拣货中" }}</span></label>
          <label v-else-if="info.pickQty === info.qty"><span class="span-picked">{{ "已拣货" }}</span></label>
        </section>
      </div>
      <div class="sub-tool">
        <label v-if="!pickSubDisable" @click="onSavePickedDetail">拣货确认</label>
        <label v-else style="background-color:#f0f0f0;color:#444;">拣货确认</label>
      </div>
    </div>

  </van-overlay>
</template>

<script>
import {ProductStatus} from "../common/constant";

export default {
  data() {
    return {
      pickSubDisable: false, // 提交按钮禁用
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: function () {
        return {
          goodsInfoResponseVO: {}
        };
      }
    }
  },
  methods: {
    ProductStatus() {
      return ProductStatus
    },
    // 发送关闭事件
    onSendClose() {
      this.$emit("closeDialog");
      this.pickSubDisable = false;
    },

    // 明细保存处理
    onSavePickedDetail() {
      let param = {
        pickingOrderId: this.info.pickingOrderId,
        productId: this.info.productId,
        bandId: this.info.bandId,
        status: this.info.status,
        qty: this.info.qty,
        slCode: this.info.slCode
      };
      if (this.pickSubDisable) {
        return
      }
      this.pickSubDisable = true;
      this.onPickedSubmit(param);
    },
    //拣货确认
    onPickedSubmit(param) {
      this.$post(this.URL.pickingConfirm, param).then(res => {
        if (res.success) {
          this.onSendClose();
          this.onPickedSubmitSuccess();
          this.$toast.success("拣货成功");
        } else {
          this.$toast.fail(res.message);
        }
        this.pickSubDisable = false;
      });
    },

    // 发送拣货确认事件
    onPickedSubmitSuccess() {
      this.$emit("pickEventSuccess");
    }
  },
};
</script>

<style lang="scss" scoped>
.van-overlay {
  padding: 3rem 1rem 1rem 1rem;
}

.content {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
  background-color: white;
  border-radius: 0.3rem;
  color: #444;

  .tool {
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: 2.6rem;
    align-items: center;
    padding: 0 0.5rem;
    font-size: 0.9rem;
    border-bottom: 1px solid #eee;

    i {
      font-size: 0.9rem;
    }
  }
}

.content-main {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 0.5rem;

  section {
    display: flex;
    width: 100%;
    height: 1.5rem;
    align-items: center;
    font-size: 0.85rem;

    label:first-child {
      display: inline-flex;
      width: 5rem;
    }

    .date {
      border: 1px solid #f0f0f0;
      border-radius: 0.2rem;
      width: 13rem;
      padding-left: 0.5rem;
      box-sizing: border-box;
      line-height: 2rem;
    }
  }
}

.span-unpick {
  color: red;
}

.span-picking {
  color: darkorange;
}

.span-picked {
  color: green;
}

.sub-tool {
  display: flex;
  width: 100%;
  height: 3rem;
  align-content: center;
  justify-content: center;
  padding-right: 1rem;
  border-top: 1px solid #eee;
  align-items: center;

  label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 2rem;
    background-color: #dc6350;
    color: white;
    font-size: 0.9rem;
    border-radius: 0.3rem;
    margin-left: 1rem;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/pickDetailDialog.vue